// extracted by mini-css-extract-plugin
module.exports = {"resizer":"clinical-portal-3__Resizer__resizer","resizerBodyCursor":"clinical-portal-3__Resizer__resizerBodyCursor","childContent":"clinical-portal-3__Resizer__childContent"};